import { Calendar, type CalendarProps } from "./calendar";

type PlainDateCalendarProps =
	| {
			mode: "single";
			value: Temporal.PlainDate | undefined;
			setValue: (date: Temporal.PlainDate | undefined) => void;
	  }
	| {
			mode: "range";
			value:
				| Readonly<
						[Temporal.PlainDate | undefined, Temporal.PlainDate | undefined]
				  >
				| undefined;
			setValue: (
				date: [Temporal.PlainDate | undefined, Temporal.PlainDate | undefined],
			) => void;
	  };

function PlainDateCalendar(props: PlainDateCalendarProps & CalendarProps) {
	const { value: selected, setValue: onSelect, mode } = props;

	let childProps: CalendarProps;
	if (mode === "single") {
		childProps = {
			...props,
			mode: "single",
			selected: TemporalToDate(selected),
			onSelect: (date: Date | undefined) => onSelect(DateToTemporal(date)),
		};
	} else {
		childProps = {
			...props,
			mode: "range",
			selected: {
				from: TemporalToDate(selected?.[0]),
				to: TemporalToDate(selected?.[1]),
			},
			onSelect: (date: { from?: Date; to?: Date } | undefined) =>
				onSelect([DateToTemporal(date?.from), DateToTemporal(date?.to)]),
		};
	}

	return <Calendar {...childProps} className="rounded-md border" />;
}

export { PlainDateCalendar };

function DateToTemporal(date: Date | undefined) {
	if (date == undefined) return undefined;
	return new Temporal.PlainDate(
		date.getFullYear(),
		date.getMonth() + 1,
		date.getDate(),
	);
}
function TemporalToDate(date: Temporal.PlainDate | undefined) {
	if (date == undefined) return undefined;
	return new Date(date.year, date.month - 1, date.day);
}
